"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// todo: questions
// - should we have what the variable equals in the name?
// - should we just number them 1 - 9

/*
$z-index-10-menu: 10;
$z-index-20-tooltip: 20;
$z-index-200-nav: 200;
$z-index-210-nav-menu: $z-index-200-nav + $z-index-10-menu;
$z-index-300-global: 300;
$z-index-310-global-menu: $z-index-300-global + $z-index-10-menu;
$z-index-500-overlay: 500;
$z-index-600-modal: 600;
$z-index-1000-immersive: 1000;
$z-index-2000-side-slide: 2000;

These are the same as Luna Style Guide
*/
var menu = 10;
var nav = 200;
var navMenu = nav + menu;
var globalZ = 300;
var globalMenu = globalZ + menu;
var overlay = 500;
var modal = 600;
var toast = 700;
var immersive = 1000;
var sideSlide = 2000;
var _default = {
  menu: menu,
  nav: nav,
  navMenu: navMenu,
  global: globalZ,
  globalMenu: globalMenu,
  overlay: overlay,
  modal: modal,
  immersive: immersive,
  sideSlide: sideSlide,
  toast: toast
};
exports.default = _default;
//# sourceMappingURL=z-index.js.map